module.exports = __webpack_public_path__ + "img/tree_layer_1.c032cbaf.png";